import { ExpressionType } from '../ExpressionType';
import createBinaryExpression from './createBinaryExpression';
export default function createEqual(left, right) {
    return createBinaryExpression(ExpressionType.Equal, left, right);
}
